import type { ReactNode } from 'react';
import classnames from 'classnames';
import styles from './List.module.css';

interface IListProps {
    bold?: boolean;
    children?: ReactNode;
    hasBullets?: boolean;
    inline?: boolean;
    items?: (JSX.Element | string)[] | undefined;
    readVariant?: 'stacked' | 'inline';
}

/**
 * @deprecated use List from the ksyos/design-system components instead. Remove if no longer used.
 */
export function List(props: IListProps) {
    const className = classnames(styles.list, {
        [styles.inline]: props.inline,
        [styles.hasBullets]: props.hasBullets,
        [styles.readVariantInline]: props.readVariant === 'inline',
        [styles.readVariantStacked]: props.readVariant === 'stacked',
    });

    return (
        <>
            {props.items && (
                <ul className={classnames(className)}>
                    {props.items.map((item, i) => (
                        <li
                            className={props.inline ? styles.inlineListItem : styles.listItem}
                            key={i}
                            style={{ fontWeight: props.bold ? 'bold' : 'normal' }}
                        >
                            {item}
                        </li>
                    ))}
                </ul>
            )}
            {props.children && <ul className={classnames(className)}>{props.children}</ul>}
        </>
    );
}

export function ListItem(props: {
    bold?: boolean;
    children: ReactNode;
    className?: string;
    color?: 'muted' | 'primary';
    inline?: boolean;
}) {
    let className = styles.listItem;

    if (props.inline) {
        className += ` ${styles.inlineListItem}`;
    }
    if (props.bold) {
        className += ` ${styles.bold}`;
    }

    if (props.color) {
        className += props.color === 'muted' ? ` ${styles.muted}` : ` ${styles.primary}`;
    }

    return <li className={classnames(className, props.className || '')}>{props.children}</li>;
}
